/**
 * Shared empty-state strings — ONE canonical source for the PDF check-block
 * partial and the dashboard CheckExpanded (Amendment §A2 / Permanent Rule 12:
 * both surfaces render identical text from the same emission).
 *
 * G-2 (Batch-RENDER-36, CORPUS-2 §G.1): an activity-level check that reads
 * EXCEEDED with ZERO findings is the degenerate not-assessable population
 * (e.g. #36 with no resource-analysable activities). Its empty body must not
 * borrow the PASS shape ("met its threshold") — it states the not-assessable
 * fact, with the check's own data_quality_warning when the engine emitted one.
 *
 * @module shared/emptyStates
 */

export const EMPTY_PASS_MESSAGE = 'This check met its threshold — no activities flagged.';

export const NOT_ASSESSABLE_MESSAGE = 'Not assessable — no activities in scope for this check.';

/**
 * Canonical empty-state text for a zero-findings check.
 * @param {object} check — canonical CheckResult
 * @returns {{ tone: 'pass'|'exceeded', message: string, note: string|null }}
 */
export function emptyStateFor(check) {
  const exceeded = check?.status_threshold === 'EXCEEDED';
  return {
    tone: exceeded ? 'exceeded' : 'pass',
    message: exceeded ? NOT_ASSESSABLE_MESSAGE : EMPTY_PASS_MESSAGE,
    note: exceeded ? (check?.data_quality_warning || null) : null,
  };
}
